export default {"src":"/_next/static/media/lab-computer.369f16b2.svg","height":45,"width":50,"blurWidth":0,"blurHeight":0};